import React, { useEffect, useRef } from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import './style.css'

const Testimonials = () => {
    const videoRefs = useRef([]);
    
    const testimonials = [
        {
            videoSrc: "/images/videos/1.webm",
            id: "testimonial-1"
        },
        {
            videoSrc: "/images/videos/2.webm",
            id: "testimonial-2"
        },
        {
            videoSrc: "/images/videos/3.webm",
            id: "testimonial-3"
        },
        {
            videoSrc: "/images/videos/4.webm",
            id: "testimonial-4"
        },
        {
            videoSrc: "/images/videos/5.webm",
            id: "testimonial-5"
        },
        {
            videoSrc: "/images/videos/6.webm",
            id: "testimonial-6"
        }
    ];

    // Carousel settings
    const carouselSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '40px'
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '20px'
                }
            }
        ]
    };

    // Handle video play - pause all others
    const handleVideoPlay = (currentIndex) => {
        videoRefs.current.forEach((video, index) => {
            if (video && index !== currentIndex && !video.paused) {
                video.pause();
            }
        });
    };

    // Add intersection observer for scroll animations
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, { threshold: 0.2 });
        
        document.querySelectorAll('.testimonial-item').forEach(item => {
            observer.observe(item);
        });
        
        return () => {
            document.querySelectorAll('.testimonial-item').forEach(item => {
                observer.unobserve(item);
            });
        };
    }, []);

    return (
        <div id="reviews" className="testimonials-section">
            {/* Islamic geometric pattern SVGs for background decoration */}
            <div className="islamic-pattern pattern-top-left">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M60 0L90 30L60 60L30 30L60 0Z" fill="rgba(0, 179, 214, 0.05)" />
                    <path d="M30 30L60 60L30 90L0 60L30 30Z" fill="rgba(0, 179, 214, 0.03)" />
                    <path d="M90 30L120 60L90 90L60 60L90 30Z" fill="rgba(0, 179, 214, 0.03)" />
                    <path d="M60 60L90 90L60 120L30 90L60 60Z" fill="rgba(0, 179, 214, 0.05)" />
                </svg>
            </div>
            <div className="islamic-pattern pattern-bottom-right">
                <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="75" cy="75" r="30" stroke="rgba(0, 179, 214, 0.04)" strokeWidth="1" />
                    <circle cx="75" cy="75" r="45" stroke="rgba(0, 179, 214, 0.03)" strokeWidth="1" />
                    <circle cx="75" cy="75" r="60" stroke="rgba(0, 179, 214, 0.02)" strokeWidth="1" />
                    <path d="M75 30L90 60H60L75 30Z" fill="rgba(0, 179, 214, 0.03)" />
                    <path d="M120 75L90 90V60L120 75Z" fill="rgba(0, 179, 214, 0.03)" />
                    <path d="M75 120L60 90H90L75 120Z" fill="rgba(0, 179, 214, 0.03)" />
                    <path d="M30 75L60 60V90L30 75Z" fill="rgba(0, 179, 214, 0.03)" />
                </svg>
            </div>
            <div className="islamic-pattern pattern-center">
                <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50 20L80 50L50 80L20 50L50 20Z" stroke="rgba(0, 179, 214, 0.02)" strokeWidth="1" />
                    <path d="M50 10L90 50L50 90L10 50L50 10Z" stroke="rgba(0, 179, 214, 0.01)" strokeWidth="1" />
                </svg>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="wpo-section-title text-center">
                            <span>Testimonials</span>
                            <h2>Students Feedback</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Slider {...carouselSettings}>
                            {testimonials.map((testimonial, index) => (
                                <div key={testimonial.id}>
                                    <div className="testimonial-item">
                                        {/* Decorative Islamic SVG elements */}
                                        <div className="testimonial-decoration top-right">
                                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30 15L40 30L30 45L20 30L30 15Z" fill="rgba(0, 179, 214, 0.03)" />
                                            </svg>
                                        </div>
                                        <div className="testimonial-decoration bottom-left">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="20" cy="20" r="10" stroke="rgba(0, 179, 214, 0.04)" strokeWidth="1" />
                                            </svg>
                                        </div>
                                        {/* Light sweep effect */}
                                        <div className="light-sweep"></div>
                                        <div className="testimonial-icon">
                                            {/* Islamic-inspired quote icon SVG */}
                                            <svg className="quote-icon" width="40" height="30" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 30L12 0H20L12 30H0ZM20 30L32 0H40L32 30H20Z" fill="#00b3d6" />
                                            </svg>
                                        </div>
                                        <div className="testimonial-video-wrapper">
                                            <video
                                                ref={el => videoRefs.current[index] = el}
                                                className="testimonial-video"
                                                src={testimonial.videoSrc}
                                                controls
                                                preload="metadata"
                                                playsInline
                                                onPlay={() => handleVideoPlay(index)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonials;